const getIndexFunc = {
  getIndexById(id, list, attribute){
    let name = attribute || 'id';
    for (let i = 0; i < list.length; i++) {
      if(list[i][name] == id){
        return i;
      }
    }

    return -1;
  }

}

module.exports = getIndexFunc;


// WEBPACK FOOTER //
// ./src/tool/getIndexFunc.js